// import { Outlet } from "react-router-dom";
// import ScrollToTop from "./ScrollToTop";


// const RootLayout = () => {
//   return (
//     <>
//       <ScrollToTop />
//       <Outlet />
//     </>
//   );
// };

// export default RootLayout;





import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "@/redux/authSlice";

import Footer from "../Footer";
import Navbar from "./Navbar";
import CookieBanner from "./CookieBanner";
import OfferBanner from "./OfferBanner";

const RootLayout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // On every load, set a flag in sessionStorage
    // sessionStorage is cleared when tab is closed, but survives refresh
    const isTabActive = sessionStorage.getItem("tabActive");

    if (!isTabActive) {
      // No flag means tab was freshly opened (not a refresh)
      // So clear the user
      dispatch(setUser(null));
      localStorage.removeItem("token");
    }

    // Set the flag — survives refresh but not tab close
    sessionStorage.setItem("tabActive", "true");

  }, [dispatch]);

  return (
    <>
      <OfferBanner />
      <CookieBanner/>
      <Navbar/>
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default RootLayout;

